<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
              >Do you want to delete this product ?</span
            >
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
              >{{ storage.productname }}</span
            >
          </v-flex>
          <v-flex xs6 pa-2>
            <v-btn
              tile
              block
              small
              depressed
              dark
              :color="appColor"
              @click="deleteProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-btn
              tile
              block
              depressed
              small
              dark
              color="#3EA56E"
              @click="deleteDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap py-2>
      <v-flex xs12 sm12 md12 lg6>
        <v-layout wrap justify-start>
          <v-flex xs12 sm3 md3 lg2 xl2 pr-md-2>
            <v-layout wrap v-if="storage">
              <v-flex xs12 v-if="storage.photos.length > 0">
                <v-img
                  :src="mediaURL + storage.photos[0]"
                  aspect-ratio="1"
                  contain
                  height="100px"
                  class="align-end"
                >
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-btn
                        tile
                        block
                        small
                        dark
                        :color="appColor"
                        style="text-capitalize"
                      >
                        <span style="border" class="ibmbold">{{
                          storage.productStatus
                        }}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-img>
              </v-flex>
              <v-flex align-self-start xs12 v-else>
                <v-img
                  :src="require('./../../../assets/Images/no-image.png')"
                  aspect-ratio="1"
                  contain
                  height="100px"
                  class="align-end"
                >
                 <v-layout wrap>
                    <v-flex xs12>
                      <v-btn
                        tile
                        block
                        small
                        dark
                        :color="appColor"
                        style="text-capitalize"
                      >
                        <span style="border" class="ibmbold">{{
                          storage.productStatus
                        }}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-img>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm9 md9 lg9 xl9>
            <v-layout wrap justify-center fill-height>
              <v-flex xs12>
                <v-layout wrap justify-start>
                  <v-flex lg12 text-left>
                    <router-link :to="'/Seller/Product/' + storage._id">
                      <span
                        style="
                          font-family: opensanslight;
                          font-size: 16px;
                          color: #000000;
                        "
                      >
                        {{ storage.name }}
                      </span>
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-end>
                <v-layout wrap justify-start>
                  <v-flex xs6 sm6 md6 lg6 xl6>
                    <v-layout wrap>
                      <v-flex text-left xs12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                        >
                          Total Stock
                        </span>
                      </v-flex>
                      <v-flex text-left xs12>
                        <span
                          style="font-family: opensansbold; font-size: 20px"
                        >
                          {{ storage.stockQuantity }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs6 sm3 md3 lg3 xl3>
                    <v-layout wrap>
                      <v-flex text-left xs12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                        >
                          Price
                        </span>
                      </v-flex>
                      <v-flex text-left xs12>
                        <span
                          style="font-family: opensansbold; font-size: 20px"
                        >
                          {{ storage.productcost }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex> -->
                  <!-- <v-flex xs6 sm3 md3 lg3 xl3>
                    <v-layout wrap>
                      <v-flex text-left lg12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                          >Markup Price</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex text-left lg12>
                        <span
                          style="
                            font-family: opensansbold;

                            font-size: 20px;
                          "
                          >{{ storage.profitmargin }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex> -->
                  <v-flex xs6 sm6 md6 lg6 xl6>
                    <v-layout wrap>
                      <v-flex text-left lg12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                          >Total price(INR)</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex text-left lg12>
                        <span
                          style="
                            font-family: opensansbold;
                            color: #3bc17a;
                            font-size: 20px;
                          "
                          >{{ storage.price }}</span
                        >
                        <br>
                        <span
                          style="
                            color: red;
                            font-family: poppinsregular;
                            font-size: 14px;
                          "
                          >Today (Rs. {{ storage.offerPrice }}, {{ storage.discount }} % Off)</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 py-2>
                    <v-layout wrap v-if="storage.isColor">
                      <v-flex xs12 py-2 text-left>
                        <span class="ibmsemibold">Available colors/Stock</span>
                      </v-flex>
                      <v-flex xs12 py-2 text-left>
                        <v-layout wrap>
                          <v-flex
                            xs1
                            sm1
                            lg1
                            pa-2
                            v-for="(item, i) in storage.colorDetails"
                            :key="i"
                          >
                            <!-- {{ item.colorHex }} -->
                            <v-avatar
                              :color="item.colorHex"
                              size="20"
                            ></v-avatar>
                            <br />
                            <span class="ibmbold">{{ item.stock }}</span>
                            <!-- <v-color-picker mode="hexa" v-model="item.colorHex"></v-color-picker> -->

                            <!-- <photoshop-picker v-model="item.colorHex"    /> -->
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex text-left xs1 text-center hidden-md-and-down>
            <v-divider vertical></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex text-left xs12 md12 lg6>
        <v-layout wrap justify-space-between fill-height>
          <v-flex sm3 md3 lg3 xl3>
            <v-layout wrap>
              <v-flex xs6 sm12>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensanslight;
                    font-size: 14px;
                  "
                >
                  Item added on
                </span>
              </v-flex>
              <v-flex xs6 sm12>
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 15px;
                    color: #000000;
                  "
                >
                  {{ formatDate(storage.create_date).slice(0, 11) }}
                  <br />
                  {{ formatDate(storage.create_date).slice(11, 20) }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm3 md3 lg3 xl3>
            <v-layout wrap fill-height>
              <v-flex xs6 sm12>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensanslight;
                    font-size: 14px;
                  "
                >
                  Available Stock
                </span>
              </v-flex>
              <v-flex xs6 sm12 text-left align-self-start>
                <span style="font-family: opensansbold; font-size: 20px">
                  {{ storage.stockQuantity }}
                </span>
              </v-flex>
              <v-flex xs6 sm12 align-self-end>
                <v-btn
                  dark
                  small
                  tile
                  depressed
                  :ripple="false"
                  :color="storage.stockQuantity > 0 ? '#FFBC6E' : '#EB6359'"
                  style="text-transform: none"
                >
                  <span
                    style="font-family: poppinsregular; font-size: 14px"
                    v-if="storage.stockQuantity > 0"
                  >
                    <v-icon>mdi-check</v-icon>
                    Available
                  </span>
                  <span
                    style="font-family: poppinsregular; font-size: 14px"
                    v-else
                  >
                    <v-icon>mdi-close</v-icon>
                    Out of Stock
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm6 md5 lg5 xl5 text-left>
            <v-layout wrap justify-start fill-height>
              <v-flex xs6 text-left align-self-start>
                <v-switch
                  :disabled="storage.productStatus == 'pending' || storage.productStatus == 'rejected' ? true : false"
                  v-model="storage.status"
                  true-value="active"
                  false-value="inactive"
                  color="#5DC57C"
                  hide-details
                  :ripple="false"
                  class="statusKey"
                  :loading="statusLoading"
                  @click="changeProductStatus(storage)"
                >
                  <template slot="label">
                    <span
                      class="text-capitalize"
                      style="
                        color: #000000;
                        font-family: opensanssemibold;
                        font-size: 16px;
                      "
                    >
                      {{ storage.status }}
                    </span>
                  </template>
                </v-switch>
              </v-flex>
              <v-flex xs12 pa-2 v-if="storage.productStatus == 'rejected'">
                <span class="appColor ibmmedium smallm">Reject reason</span> <br>
                <span class="appColor ibmregular smallm">{{ storage.rejectReason }}</span>
              </v-flex>
              <v-flex xs12 xl12 align-self-end>
                <v-layout wrap justify-space-between>
                  <v-flex xs5 sm5 md5 lg5 xl5>
                    <v-btn
                      tile
                      block
                      small
                      outlined
                      color="warning"
                      style="text-transform: none"
                      :to="'Product/Edit/' + storage._id"
                    >
                      <span
                        style="
                          color: #000;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        <v-icon left>mdi-pencil</v-icon>
                        Edit
                      </span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-icon :color="appColor" @click="deleteDialogue = true">mdi-delete</v-icon>
                  </v-flex>
                  <!-- <v-flex xs5>
                    <v-btn
                      tile
                      block
                      small
                      outlined
                      color="warning"
                      style="text-transform: none"
                      :to="
                        storage.currenttype == 'Offer' ||
                        storage.currenttype == 'Deals'
                          ? '/Seller/Offers/Add/' + storage._id
                          : ''
                      "
                    >
                      <span
                        style="
                          color: #000;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        In {{ storage.currenttype }}
                      </span>
                    </v-btn>
                  </v-flex> -->
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import { Photoshop } from 'vue-color'
export default {
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      statusLoading: false,
      deleteDialogue: false,
      colors: "#ff009688",
      name: "",
    };
  },
  components: {
    // 'photoshop-picker': Photoshop
  },
  methods: {
    changeProductStatus(item) {
      this.statusLoading = true;

      axios({
        method: "POST",
        url: "/product/status/change/" + item._id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          // id: item._id,
          status: item.status,
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.msg = "Product Status Changed to " + item.status;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/delete/"+this.storage._id,
        headers: {
          "token": localStorage.getItem("token"),
        },
        params: {
          // id: this.storage._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style>
div.vertical-line {
  width: 1px; /* Line width */
  background-color: #8d8d8d; /* Line color */
  height: 100%; /* Override in-line if you want specific height. */
  float: left; /* Causes the line to float to left of content. 
        You can instead use position:absolute or display:inline-block
        if this fits better with your design */
}
.statusKey.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>